let config = {
  isHomeShope: true, /// make false when give Homeshop build for client
  isShowTaskTab: true, /// make false when give multiTenant store module build for client

  //// -----------------------[Ticketing bulkupload code]--------------------------------------------
  hierarchyTemplate: [
    ["Designation", "ReportTo", "Status"],
    ["HOD", "Root", "Active"],
    ["Manager", "HOD", "Active"],
  ],
  priorityTemplate: [
    ["PriorityName", "Status"],
    ["Hight", "Active"],
    ["Medium", "Active"],
    ["Low", "In-Active"],
  ],
  userTemplate: [
    [
      "UserName",
      "FirstName",
      "LastName",
      "Mobile Number",
      "User Email ID",
      "User Designation",
      "Reportee Designation",
      "Reports To",
      "CRM Role",
      "Copy Escalation",
      "Assign Escalation",
      "Escalation Agent Name",
      "Status",
    ],
    [
      "Shlok.barot",
      "Shlok",
      "Barot",
      "9665958060",
      "shlok@gmail.com",
      "Executive",
      "Manager",
      "Chetan",
      "Admin",
      "Yes",
      "Yes",
      "Vikas",
      "Active",
    ],
    [
      "Mangesh.Mishra",
      "Mangesh",
      "Mishra",
      "9665958060",
      "mangesh@gmail.com",
      "Executive",
      "Supervisor",
      "Chetan",
      "Admin",
      "Yes",
      "Yes",
      "Vikas",
      "Active",
    ],
  ],
  alertTemplate: [
    ["AlertType", "Communication Mode", "Status"],
    ["Mail", "Mail,Sms", "Active"],
    ["Agent Call", "Mail,Sms", "Active"],
  ],
  categoryTemplate: [
    ["BrandName", "Category", "SubCategory", "IssueType", "Status"],
    ["Tata", "Category-1", "SubCat-1", "IssueType-1", "Active"],
    ["Bata", "Category-2", "SubCat-2", "IssueType-2", "In-Active"],
  ],

  crmRoleTemplate: [
    ["RoleName", "Status", "EnabledModules", "DisabledModules"],
    [
      "HOD",
      "InActive",
      "Dashboard|Tickets|Knowledge Base",
      "Settings|Chat|Notification|Reports",
    ],
    [
      "Agent",
      "Active",
      "Dashboard|Tickets|Knowledge Base",
      "Settings|Chat|Notification|Reports",
    ],
  ],
  storeTemplate: [
    [
      "Brand",
      "City",
      "State",
      "PinCode",
      "StoreName",
      "Address",
      "StoreCode",
      "Region",
      "Zone",
      "StoreType",
      "StoreEmailID",
      "StorePhoneNo",
      "Status",
      "IsStorePayEnable",
      "latitude",
      "longitude",
      "PickupLocation",
      "StoreType1",
      "StoreType2",
      "StoreManagerName",
      "StoreManagerMobile",
      "Designation",
      "Shoppingassissted",
      "storetiming",
      "DayStatus",
      "OpenDays",
      "OpeningTime",
      "ClosingTime",
      "StartDate",
      "EndDate",
      "Storevalue",
      "Storename_address_pincode",
      "Store_Ownership",
      "Store_Channel",
      "Is_whatsappenable",
      "tier",
      "StoreGSTNo",
      "StoreCIN",
      "StorePan",
      "IsWhatsApp",
      "IsBell",
      "IsWebBot",
      "IsShoppingBag",
      "IsERPayment",
      "IsERShipping",
      "IsOrderSync",
      "IsSendToShipmentManual",
      "IsDigitalReceipt",
      "IsStateHub",
      "IsCityHub",
      "IsBrandHub",
      "TempletId",
    ],
    [
      "Paragon",
      "Mumbai",
      "Maharashtra",
      "380001",
      "Store-Name-01",
      "Store-address-01",
      "Store-Code-01",
      "West",
      "East",
      "Commercial",
      "Store01@gmail.com",
      "909090909",
      "Active",
      "1",
      "98.0909878",
      "98.0897872",
      "Bandra",
      "",
      "",
      "Dheeraj",
      "9988009988",
      "HR",
      "ABCD",
      "07:00:00",
      "OPEN",
      "ALL",
      "08:00:00",
      "10:00:00",
      "07-01-2021",
      "7/20/2021",
      "AD",
      "ABC",
      "ABCD",
      "ERT",
      "1",
      "GOLD",
      "FGHIJ",
      "9850",
      "ABCDE4534I",
      "Y",
      "Y",
      "Y",
      "Y",
      "Y",
      "Y",
      "Y",
      "Y",
      "Y",
      "0",
      "0",
      "1",
      "0",
    ],
    [
      "BATA",
      "Ahmedabad",
      "Gujarat",
      "370001",
      "Store-Name-02",
      "Store-address-02",
      "Store-Code-02",
      "East",
      "West",
      "Retail",
      "Store02@gmail.com",
      "909090909",
      "In-Active",
      "0",
      "98.0909878",
      "98.0897872",
      "Bandra",
      "",
      "",
      "Dheeraj",
      "9988009988",
      "HR",
      "ABCD",
      "07:00:00",
      "OPEN",
      "ALL",
      "08:00:00",
      "10:00:00",
      "07-01-2021",
      "7/20/2021",
      "AD",
      "ABC",
      "ABCD",
      "ERT",
      "1",
      "GOLD",
      "FGHIJ",
      "9850",
      "ABCDE4534I",
      "Y",
      "Y",
      "Y",
      "Y",
      "Y",
      "Y",
      "N",
      "Y",
      "N",
      "1",
      "1",
      "0",
      "2",
    ],
  ],
  ///// ------------------------------------ [Store bulkupload code]-----------------------------------------------
  itemMasterTemplate: [
    [
      "BrandName",
      "ItemCode",
      "ItemName",
      "DepartmentName",
      "ItemCat",
      "ItemSubCategory",
      "ItemGroup",
    ],
    [
      "Amazon",
      "Item-A1",
      "Black Sneakers",
      "Casual Shoes",
      "Shoes",
      "Casual Shoes",
      "Shoes",
    ],
    [
      "Amazon",
      "Item-B1",
      "White Sneakers",
      "Casual Shoes",
      "Shoes",
      "Casual Shoes",
      "Shoes",
    ],
  ],
  claimCategoryTemplate: [
    ["BrandName", "Category", "SubCategory", "IssueType", "StatusID"],
    ["EasyRewarz", "Exchange", "Defective Article", "Broken Shoe", "Active"],
    ["EasyRewarz", "Exchange", "Defective Article", "Broken Shoe", "Active"],
  ],
  slaTemplate: [
    [
      "IssueType",
      "Priority",
      "SLABreachPercent",
      "RespondValue",
      "RespondDuration",
      "ResolutionValue",
      "ResolutionDuration",
      "Status",
    ],
    ["Issue1", "High", "30", "1", "Day", "2", "Day", "Active"],
    ["Issue1", "Medium", "30", "1", "Day", "2", "Day", "Active"],
    ["Issue1", "Low", "30", "1", "Day", "2", "Day", "Active"],
  ],
  Store_HierarchyTemplate: [
    ["Designation", "ReportTo", "Status"],
    ["HOD", "Root", "Active"],
    ["Manager", "HOD", "Active"],
  ],

  campaignTemplate: [["CampaignName", "Script"]],
  departmentTemplate: [
    ["Brand", "StoreCode", "Department", "Function", "Status"],
    ["Paragon", "TestStoreBulkasf", "Department 10", "Function10-1", "Active"],
  ],

  retargetFlowTemplate: [["MobileNumber","CustomerName","DateOfAbandoned","Time","Channel","StoreCode","Address1","Address2","PinCode","City","State","StoreAddress",
  "ProductId","ItemName","ItemPrice","Quantity","ProductCategory","CartId","Email","PurchaseCategory","IsBrowsingAbandon","IsCartabandon","IsPurchaseAbandon","IsPurchaseFailure","ImageUrl","CheckoutUrl","TotalAmount"]],
  
  storeUserTemplate: [
    [
      "Brand",
      "StoreCode",
      "UserName",
      "UserCode",
      "MobileNumber",
      "UserEmailID",
      "Department",
      "Function",
      "UserDesignation",
      "ReporteeDesignation",
      "ReportsTo",
      "CRMRole",
      "Status",
      "ClaimApprover",
    ],
    [
      "EZWards brand",
      "EZ001",
      "abc",
      "abc@23",
      "8097654323",
      "abc@gmail.com",
      "Department-1",
      "Function-1",
      "CXO",
      "CTTO",
      "xyz",
      "Admin",
      "Active",
      "Yes",
    ],
  ],
  storeSlaTemplate: [
    [
      "FunctionType",
      "Priority",
      "SLABreachPercent",
      "ResolutionValue",
      "ResolutionDuration",
      "Status",
    ],
    ["Function1", "High", "30", "2", "Day", "Active"],
    ["Function1", "Medium", "30", "2", "Day", "Active"],
    ["Function1", "Low", "30", "2", "Day", "Active"],
  ],
  storeOrder_Template: [
    [
      "Template Name",
      "Height",
      "Length",
      "Breadth",
      "Unit",
      "Weight",
      "WeightUnit",
    ],
    ["template1", "5", "8", "5.5", "CM", "5", "KG"],
    ["template2", "6", "9", "7.5", "CM", "5", "KG"],
  ],
  slot_Template: [
    [
      "StoreCode",
      "OperationalDays",
      "TemplateName",
      "SlotStartTime",
      "SlotEndTime",
      "SlotOccupancy",
      "SlotStatus",
      "Slotdaysneedtodisplay",
      "Applicablefrom",
      "MaxPeoplePerApt",
      "DisplaySlotCode",
      "SlotSettingStatus",
    ],
    [
      "SMB3024",
      "Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday",
      "Manual template 3",
      "10:00 AM",
      "10:30 AM",
      "2",
      "1",
      "10",
      "2020-12-01",
      "10",
      "302",
      "Active",
    ],
    [
      "SMB3024",
      "Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday",
      "Manual template 3",
      "10:30 AM",
      "11:00 AM",
      "2",
      "1",
      "10",
      "2020-12-01",
      "10",
      "302",
      "Active",
    ],
    [
      "SMB3024",
      "Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday",
      "Manual template 3",
      "6:00 PM",
      "6:30 PM",
      "2",
      "1",
      "10",
      "2020-12-01",
      "10",
      "302",
      "Active",
    ],
  ],
  lastUpdatedDate: "14-07-2022",
  appVersion: "V1.9",
  url: window.location.origin,
  //*******For Local**************//
   //apiUrl: "https://localhost:5001/api",
  // socketUrl: "ws://localhost:4000",
  // soundURL:
  //   "https://multitenancyshopsterapiv2.dcdev.brainvire.net/Uploadfiles/Chat/ChatBotSoundFiles/",
  // url: "https://multitenancyshopsterv2.dcdev.brainvire.net",
  //  pageRefreshTiming: 60000
  //****************************//
  //*******For Multi Tenante shopster v2*******//
  // apiUrl: "https://multitenancyshopsterapiv2.dcdev.brainvire.net/Api",
  // socketUrl: "wss://bvsocketservermts.dcdev.brainvire.net",
  // soundURL:
  //   "https://multitenancyshopsterapiv2.dcdev.brainvire.net/Uploadfiles/Chat/ChatBotSoundFiles/",
  // url:"https://multitenancyshopsterv2.dcdev.brainvire.net",
  //  pageRefreshTiming: 60000
  //*****************************************//
  //*******For Shopster QA*******//
  apiUrl: process.env.REACT_APP_BASE_URL,
  socketUrl: process.env.REACT_APP_SOCKET_URL,
  soundURL: process.env.REACT_APP_SOUND_URL,
  videosocketUrl: process.env.REACT_APP_VIDEOSOCKET_URL,
  // url: "https://qa-ui.shopster.live",
  //  pageRefreshTiming: 60000
  //*******For Shopster QA*******//
  //  apiUrl: "https://qa-api.shopster.live/Api",
  //  socketUrl: "wss://qa-api-socketnd.shopster.live",
  //  soundURL: "https://qa-api.shopster.live/Uploadfiles/Chat/ChatBotSoundFiles/",
  // url: "https://qa-ui.shopster.live",
  // videosocketUrl: "https://ndjs-test-video.shopster.chat",
  //misUrl:"https://qa-ui-misdashboard.shopster.live/?UserID=",
  //webbotUrl: "https://qa-{programcode}.shopster.chat/api/v1/webbot/getcartdetailsforbell",
  //pageRefreshTiming: 60000,
  //****************************//
  //*******For Shopster UAT*******//
  // apiUrl: 'https://api-preprod.shopster.live/Api',
  // socketUrl: "wss://ndjs-preprod.shopster.live",
  // soundURL:"https://api-preprod.shopster.live/Uploadfiles/Chat/ChatBotSoundFiles/",
  // url:"https://ui-preprod.shopster.live",
  misUrl :"https://dashboard.shopster.live/?UserID=",
  webbotUrl: "https://{programcode}.shopster.chat",
  pageRefreshTiming: 60000,
  sitekey: "6LcY5MUeAAAAAGUXkqMTKfIWl00f_8bz-DFNd0ER",
  // videosocketUrl:"https://ndjs-uat-video.shopster.chat",
  //****************************//
  //*******For Shopster LIVE*******//
  // apiUrl: "https://api.shopster.live/Api",
  // socketUrl: "wss://ndjs.shopster.live",
  // soundURL:"https://api.shopster.live/Uploadfiles/Chat/ChatBotSoundFiles/",
  // url:"https://www.shopster.live",
  //  pageRefreshTiming: 60000
  //****************************//
};

export default config;
